import posthog from 'posthog-js';
import { NavigateFunction } from 'react-router-dom';
import { routes } from 'services/RouteService';

/** Opens a category page, recording where it was opened from. */
export function openCategory(navigate: NavigateFunction, slug: string, openedFrom: string) {
  posthog.capture('info.category_opened', { category_slug: slug, opened_from: openedFrom });
  navigate(routes.infoCategory.route.replace(':slug', slug));
}
